import { Component, OnInit } from '@angular/core';
import { ModalExtended} from 'ngx-dynamic-modal';
import  { ElementCacheService} from '../../services/element-cache.service';

@Component({
  selector: 'app-element-cache-view-modal',
  templateUrl: './element-cache-view-modal.component.html',
  styleUrls: ['./element-cache-view-modal.component.scss']
})
export class ElementCacheViewModalComponent extends ModalExtended implements OnInit {
    data: any;
    view: any;
    enabled: boolean;

  constructor(private  elementCacheService: ElementCacheService) {
      super();
  }

  ngOnInit() {
      this.enabled=true;
      //console.log(this.data.entry)
      this.elementCacheService.getElementCacheEntry(this.data.entry)
          .subscribe(result => {
              this.view=result;
          }, error => {
              console.log(error);
          }, () => {
              this.enabled=false;
          })
  }

}





// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/elements/modals/element-cache-view-modal/element-cache-view-modal.component.ts